import { render } from "./NewLocation.vue?vue&type=template&id=8b5d5cae"
import script from "./NewLocation.vue?vue&type=script&lang=js"
export * from "./NewLocation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__